import HomeIcon from "@mui/icons-material/Home";
import InsightsIcon from "@mui/icons-material/Insights";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import PaidIcon from "@mui/icons-material/Paid";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
export const Categories = [
  {
    id: "gettingstartwithtipkit",
    title: "Getting Started with Tipkit",
    short:
      "Learn how Tipkit simplifies digital tipping for hotels, making it easy for guests, staff, and managers to connect effortlessly.",
    icon: <HomeIcon sx={{ fontSize: 30, color: "primary.main" }} />,
  },
  {
    id: "tippingandpayments",
    title: "Tipping & Payments",
    short:
      "Understand tipping etiquette, payout timing, and how Tipkit ensures transparency.",
    icon: <PaidIcon sx={{ fontSize: 30, color: "#ffe135" }} />,
  },
  {
    id: "hotelandstaffguide",
    title: "Hotel & Valet Staff Guide",
    short:
      "Resources to help your team earn more tips and build stronger guest connections.",
    icon: <Groups2OutlinedIcon sx={{ fontSize: 30, color: "warning.main" }} />,
  },
  {
    id: "digitaltiping",
    title: "Digital Tipping 101",
    short:
      "Learn the basics of contactless, cashless tipping and why hotels are switching.",
    icon: <TipsAndUpdatesIcon sx={{ fontSize: 30, color: "#edc001" }} />,
  },
  {
    id: "benefits",
    title: "Benefits of Digital Tipping with Tipkit",
    short:
      "Digital tipping through Tipkit helps hotels and hospitality teams create stronger, more motivated, and longer-lasting staff relationships. By making tipping transparent, efficient, and easy to manage, Tipkit helps reduce turnover while improving morale across the team.",
    icon: <InsightsIcon sx={{ fontSize: 30, color: "success.main" }} />,
  },
  {
    id: "technicalSupport",
    title: "Technical Support",
    short:
      "Troubleshooting and setup guides for hotel managers and valet teams.",
    icon: (
      <SupportAgentOutlinedIcon sx={{ fontSize: 30, color: "#e0128e" }} />
    ),
  },
];